<app-barra-crud [state]="state" (salvando)="salvar()" (voltando)="busca()" (inserindo)="novo()" (editando)="editar()"
  (excluindo)="excluir()" (cancelando)="cancelar()" [formValido]="f.valid">
</app-barra-crud>
<div class="conteudo cadastro">
  <form role="form" #f="ngForm" novalidate>
    <nav class="topo-abas">
      <div class="nav nav-tabs" id="nav-tab" role="tablist">
        <a translate id="dados-principais-tab" href="#dados-principais" aria-controls="dados-principais"
          aria-selected="true" class="nav-item nav-link active" data-toggle="tab" role="tab">
          {{'parametros.grupoEconomico.cadastro.dadosPrincipais.abaDadosPrincipais'}}
        </a>
      </div>
    </nav>
    <div class="tab-content" id="nav-tabContent">
      <div id="dados-principais" aria-labelledby="dados-principais-tab" class="tab-pane fade show active"
        role="tabpanel">
        <header translate class="titulo">{{'parametros.grupoEconomico.cadastro.dadosPrincipais.abaDadosPrincipais'}}</header>
        <div class="container-fluid">
          <div class="row">
            <div class="col col-lg-12">
              <small translate class="text-info">{{'parametros.grupoEconomico.cadastro.CampoObrigatorio'}}</small>
              <hr />
            </div>
          </div>
          <div class="row">
            <app-text-box [state]="state" class="col-lg-3"
              label="{{'parametros.grupoEconomico.cadastro.dadosPrincipais.idGrupoEconomico' | translate}}" name="idGrupoEconomico"
              [(ngModel)]="model.id"
              placeholder="{{'parametros.grupoEconomico.cadastro.dadosPrincipais.idGrupoEconomicoPlaceHolder' | translate}}"
              [ativo]="false"></app-text-box>
          </div>
          <div class="row">
            <app-text-box [state]="state" class="col-lg-6"
              label="{{'parametros.grupoEconomico.cadastro.dadosPrincipais.descricao' | translate}}" name="descricao"
              [(ngModel)]="model.descricao" obrigatorio="true" required
              placeholder="{{'parametros.grupoEconomico.cadastro.dadosPrincipais.descricaoPlaceHolder' | translate}}">
            </app-text-box>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>